import { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StandardButton from '@components/common/StandardButton';
import { SubmitConfirmationModal } from './SubmitConfirmationModal';

type Props = {
  canSubmit: boolean;
  hasSignature: boolean;
  isSubmitting: boolean;
  isSkipped: boolean;
  signaturePreviewUrl?: string | null;
  printedName?: string;
  onSubmitWithAcknowledgment: () => void;
  onSubmitWithoutAcknowledgment: () => void;
};

export const SubmitButton = ({
  canSubmit,
  hasSignature,
  isSubmitting,
  isSkipped,
  signaturePreviewUrl,
  printedName,
  onSubmitWithAcknowledgment,
  onSubmitWithoutAcknowledgment
}: Props) => {
  const { t } = useTranslation('customerReview');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    if (isSkipped) {
      onSubmitWithoutAcknowledgment();
    } else {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    if (!isSubmitting) {
      setIsModalOpen(false);
    }
  };

  const handleConfirm = (includeAcknowledgment: boolean) => {
    if (includeAcknowledgment) {
      onSubmitWithAcknowledgment();
    } else {
      onSubmitWithoutAcknowledgment();
    }
  };

  const buttonSx = {
    py: 1.5,
    height: 'auto',
    minWidth: isMobile ? '100%' : 200,
    width: isMobile ? '100%' : 'auto'
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <StandardButton
          variant="primary"
          disabled={!canSubmit || isSubmitting || (!isSkipped && !hasSignature)}
          onClick={handleClick}
          sx={buttonSx}
        >
          {t('acknowledgment.submitAndComplete')}
        </StandardButton>
      </Box>

      <SubmitConfirmationModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
        isSubmitting={isSubmitting}
        hasSignature={hasSignature}
        signaturePreviewUrl={signaturePreviewUrl}
        printedName={printedName}
      />
    </>
  );
};
